module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/k8kaIp/tc-custom/9781460388914.jpg?1728259236055",
      "alt": "This image is the cover for the book Home for His Family"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Home for His Family\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_c('b', [_vm._v("The Rancher's Ready-Made Family")])]), _c('i', [_c('b')]), _c('br'), _c('br'), _vm._v("Nate Colby came to the Dakota Territory to start over, not to look for a wife. He'll raise his orphaned nieces and nephew on his own, even if pretty schoolteacher Sarah MacFarland's help is a blessing. But Nate resists getting too closeSarah deserves better than a man who only brings trouble to those around him. "), _c('br'), _c('br'), _vm._v("Sarah can't deny she cares for the children, but she can't let herself fall for Nate. Her childhood as an orphan taught her that opening her heart to love only ends in hurt. Yet helping this ready-made family set up their ranch only makes her long to be a part of itwhatever the risk.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jan Drexler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jan was raised in Michigan, and since her marriage more than thirty years ago has lived throughout the Midwest. Her first love was homeschooling, but when her youngest son graduated she asked God to give her something useful to do for the next phase of her life. The answer was a computer and the deep well of family stories handed down from her parents and grandparents. A lover of history and the outdoors, Jan spends her spare time hiking in the Black Hills of South Dakota with her family.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0